import { defineComponent as _defineComponent } from 'vue';
import ObjectStoreRestrictionSpan from "./ObjectStoreRestrictionSpan.vue";
import QuotaUsageBar from "@/components/User/DiskUsage/Quota/QuotaUsageBar.vue";
import { QuotaSourceUsageProvider } from "@/components/User/DiskUsage/Quota/QuotaUsageProvider.js";
import ObjectStoreBadges from "./ObjectStoreBadges.vue";
import ConfigurationMarkdown from "./ConfigurationMarkdown.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DescribeObjectStore',
    props: {
        storageInfo: null,
        what: null
    },
    setup(__props, { expose }) {
        const props = __props;
        const quotaSourceLabel = computed(() => { var _a; return (_a = props.storageInfo.quota) === null || _a === void 0 ? void 0 : _a.source; });
        const isPrivate = computed(() => props.storageInfo.private);
        const badges = computed(() => props.storageInfo.badges);
        expose({
            isPrivate,
        });
        return { __sfc: true, props, quotaSourceLabel, isPrivate, badges, ObjectStoreRestrictionSpan, QuotaUsageBar, QuotaSourceUsageProvider, ObjectStoreBadges, ConfigurationMarkdown };
    }
});
